export enum TopicName {
    UserToAircraftCommand = "UserToAircraftCommand",
    UserStatus = "UserStatus",
    InterPilot = "InterPilot",
    AirText = "AirText",
    PluginCommand = "PluginCommand",
}